module.exports = __webpack_public_path__ + "img/pantalla-9-10.05d1f96f.png";